import { render, staticRenderFns } from "./payList2022.vue?vue&type=template&id=17d8a20d&scoped=true&"
import script from "./payList2022.vue?vue&type=script&lang=js&"
export * from "./payList2022.vue?vue&type=script&lang=js&"
import style0 from "./payList2022.vue?vue&type=style&index=0&id=17d8a20d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d8a20d",
  null
  
)

export default component.exports